import { FC } from "react";
import {
    Box,
    Flex,
    Text,
    Icon,
    Link,
} from "@smile2impress/components/relaunch";

import { FollowUsProps } from "./FollowUs.types";

export const FollowUs: FC<FollowUsProps> = ({ content }) => {
    return (
        <Flex
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
        >
            <Box maxW="700px" mb={2}>
                <Text textStyle="H2" textAlign="center" mb={0.7}>
                    {content.title}
                </Text>
                <Text textStyle="body" textAlign="center">
                    {content.subtitle}
                </Text>
            </Box>
            {content.socials && (
                <Box px={2} py={["0px", "0px", "40px"]}>
                    {content.socials.map((social) => (
                        <Link
                            key={social.link}
                            href={social.link}
                            w={["48px", "48px", "64px"]}
                            h={["48px", "48px", "64px"]}
                            mr={"40px"}
                            _last={{ mr: 0 }}
                        >
                            <Icon
                                as={social.icon}
                                color="base.halfBlack"
                                w={["48px", "48px", "64px"]}
                                h={["48px", "48px", "64px"]}
                            />
                        </Link>
                    ))}
                </Box>
            )}
        </Flex>
    );
};
